var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.865,
    height: 32.375,
    viewBox: "0 0 44.865 32.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -61)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.135 61)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.616,61H27.42a4.12,4.12,0,0,0-1.7.374L45.93,80.408l4.53-4.1h0L66.316,61.375A4.121,4.121,0,0,0,64.616,61Z",
    transform: "translate(-25.721 -61)",
    fill: "#00a85b"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.439 63.136)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.266,86.728,338.213,100.78l14.052,14.052a3.692,3.692,0,0,0,.374-1.6v-24.9A3.692,3.692,0,0,0,352.266,86.728Z",
    transform: "translate(-338.213 -86.728)",
    fill: "#00a85b"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 63.135)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.374,86.721A3.692,3.692,0,0,0,0,88.321v24.9a3.693,3.693,0,0,0,.374,1.6l14.053-14.052Z",
    transform: "translate(0 -86.721)",
    fill: "#00a85b"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.135 78.948)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.389,277.211l-4.53,4.1a1.38,1.38,0,0,1-1.869,0l-4.354-4.1L25.714,291.263a4.12,4.12,0,0,0,1.7.375h37.2a4.12,4.12,0,0,0,1.7-.374Z",
    transform: "translate(-25.714 -277.211)",
    fill: "#00a85b"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.d1e8a8920c50d7efcd1ec3c74b1556d0.svg";
export { ForwardRef as ReactComponent };